export default "__VITE_ASSET__CgOQ3uZC__";